import {useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminCampanhaModal from './modal';
import './style.css';
import {formatDate, formatImage, getHoje} from "components/formatos";
import config from 'config';
import {CidadeContext} from "services/cidade";
import PAGINACAO from "components/paginacao";

function AdminCampanha() {
    const [lcampanha, setLCampanha] = useState([]);
    const [iesativa, setIesativa] = useState('S');

    // Modal
    const [operacao, setOperacao] = useState('');
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const { cod_cidade } = useContext(CidadeContext);

    function closeAdminCampanhaModal() {
        setIsOpen(false);
    }

    useEffect(() => {
        api.get(`${config.ADM_CAMPANHA}?cod_cidade=${cod_cidade}`)
            .then(response => {
                setLCampanha(response.data);
            });
    }, [isOpen, cod_cidade]);

    function novaCampanha() {
        setDados({
            'id_campanha': 0,
            'den_campanha': '',
            'validade_ini': getHoje(),
            'validade_fim': getHoje(),
            'banner': '',
            'cod_cidade': cod_cidade
        });
        setIsOpen(true);
    }

    function editarCampanha(linha) {
        api.get(`${config.ADM_CAMPANHA}/${linha.id_campanha}`)
            .then(response => {
                setOperacao('UPDATE');
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err);
            });
    }

    // Filtra campanhas ativas se iesativa === 'S'
    const hoje = getHoje();
    const campanhasFiltradas = iesativa === 'S'
        ? lcampanha.filter(c => new Date(c.validade_fim) >= new Date(hoje))
        : lcampanha;

    return (
        <div>
            <AdminCampanhaModal
                isOpen={isOpen}
                onRequestClose={closeAdminCampanhaModal}
                operacao={operacao}
                dados={dados}
            />
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Gestão de Campanhas</h2>
                    <button 
                        className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2" 
                        onClick={novaCampanha}
                        style={{ borderRadius: '12px' }}
                    >
                        <i className="fas fa-plus"></i>
                        <span>Nova Campanha</span>
                    </button>
                </div>
                
                <div className="modern-filter-bar mt-4 p-3 bg-card-admin rounded-4">
                    <div className="form-check form-switch d-flex align-items-center gap-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="switchAtivas"
                            checked={iesativa === 'S'}
                            onChange={e => setIesativa(e.target.checked ? 'S' : 'T')}
                            style={{ width: '45px', height: '22px', cursor: 'pointer' }}
                        />
                        <label className="form-check-label fw-bold text-muted mb-0" htmlFor="switchAtivas" style={{ cursor: 'pointer' }}>
                            {iesativa === 'S' ? 'Visualizando Campanhas Ativas' : 'Visualizando Todas as Campanhas'}
                        </label>
                    </div>
                </div>
            </div>

            <PAGINACAO
                data={campanhasFiltradas}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems.map((e, index) => {
                            const estaAtiva = new Date(e.validade_fim) >= new Date(hoje);
                            return (
                                <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`camp-${index}`}>
                                    <div className="campanha-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarCampanha(e)}>
                                        <div className="campanha-status-badge">
                                            <span className={`badge ${estaAtiva ? 'bg-success' : 'bg-secondary'}`}>
                                                {estaAtiva ? 'Ativa' : 'Encerrada'}
                                            </span>
                                        </div>
                                        
                                        <div className="campanha-banner-container bg-light" style={{ height: '140px' }}>
                                            {formatImage(e.banner) ? (
                                                <img src={formatImage(e.banner)} alt={e.den_campanha} className="w-100 h-100 object-fit-cover" />
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center h-100 text-muted opacity-25">
                                                    <i className="fas fa-image fa-3x"></i>
                                                </div>
                                            )}
                                        </div>

                                        <div className="p-4">
                                            <div className="text-muted small mb-1 fw-bold">ID: #{e.id_campanha}</div>
                                            <h4 className="campanha-title mb-3 text-truncate-2" title={e.den_campanha}>
                                                {e.den_campanha}
                                            </h4>
                                            
                                            <div className="campanha-dates mt-auto">
                                                <div className="d-flex align-items-center text-muted small mb-2">
                                                    <i className="far fa-calendar-alt me-2 text-primary"></i>
                                                    <span>Início: <strong>{formatDate(e.validade_ini)}</strong></span>
                                                </div>
                                                <div className="d-flex align-items-center text-muted small">
                                                    <i className="fas fa-hourglass-end me-2 text-primary"></i>
                                                    <span>Final: <strong>{formatDate(e.validade_fim)}</strong></span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="campanha-actions p-3 border-top bg-light-subtle d-flex justify-content-end">
                                            <button className="btn btn-outline-primary btn-sm rounded-3 px-3">
                                                <i className="fas fa-edit me-1"></i> Editar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            />
        </div>
    );
}

export default AdminCampanha;